<tt-page>
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-list [ttData]="itemsListOeeDashboard"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="oeedashboard_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-list [ttData]="itemsListOeeDashboard"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
